import { getPrimaryTextClass } from "helpers/sf_utils";
import React from "react";
import { Col, Input, Label, Row } from "reactstrap";

const TranscriptionHeader = ({value, onChange}) => {
    return (
        <Row className="pb-3">
            <Col className='d-flex align-items-center'>
                <i className={`${getPrimaryTextClass()} bx font-size-20 me-2 bx-phone-call`} />
                <Label className="mb-0 font-weight-semibold fs-16">Call Transcription</Label>
            </Col>
            <Col md="auto" className="align-self-center">
                    <div className="search-box d-inline-block">
                        <div className="position-relative">
                            {/* TODO: Use SearchBar Instead like in Adgroups.js */}
                            <Input
                                className="rounded"
                                style={{width: "300px"}}
                                placeholder="Search for anything in conversation"
                                type="text"
                                value={value}
                                onChange={onChange}
                            />
                            <i className="bx bx-search-alt search-icon" />
                        </div>
                    </div>
            </Col>
        </Row>
    )
}

export default TranscriptionHeader;